import React from 'react';

import SiteContact from './SiteContact';

/** The copyright line and the contact line, the same under every screen. */
const FooterContent = () => (
  <>
    <p>&copy; {new Date().getFullYear()} jookable &trade;</p>
    <SiteContact />
  </>
);

export default FooterContent;
